import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './RedeemNotificationBanner.css';

function RedeemNotificationBanner({ notification, onDismiss }) {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  // Trigger slide-down animation
  useEffect(() => {
    if (notification) {
      // Small delay to trigger CSS transition
      const timer = setTimeout(() => setIsVisible(true), 50);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [notification]);

  if (!notification) {
    return null;
  }

  const handleGoToRedeem = () => {
    navigate('/redeem');
    onDismiss();
  };

  const handleClose = () => {
    setIsVisible(false);
    // Wait for animation to complete before removing from DOM
    setTimeout(onDismiss, 300);
  };

  return (
    <div className={`redeem-notification ${isVisible ? 'redeem-notification--visible' : ''}`}>
      <div className="redeem-notification__container">
        <div className="redeem-notification__icon">
          🎉
        </div>
        <div className="redeem-notification__content">
          <h3 className="redeem-notification__title">Round Ended - You Can Redeem!</h3>
          <p className="redeem-notification__message">
            Game #{notification.gameId} has ended. You held <strong>{notification.balance}</strong> tokens.
            Visit the Redeem page to claim your share of the reserve vault.
          </p>
        </div>
        <button
          type="button"
          className="redeem-notification__action"
          onClick={handleGoToRedeem}
        >
          Go to Redeem
        </button>
        <button
          type="button"
          className="redeem-notification__close"
          onClick={handleClose}
          aria-label="Close notification"
        >
          ×
        </button>
      </div>
    </div>
  );
}

export default RedeemNotificationBanner;
